<template>
    <v-dialog
    v-model="globalDialog"                
    width="400"
    persistent
    >        
        <v-card>
            <v-card-title
            class="grey lighten-2 title"
            primary-title
            >
            <div>
                {{this.globalDialogData.titulo}}    <br>                 
            </div>                                             
            </v-card-title>                            
            <v-card-text>
                {{this.globalDialogData.contenido}}
            </v-card-text>                        
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                flat
                @click="closeDialog()"
            >
                Cerrar
            </v-btn>
            <v-btn
                v-if="$store.state.printhref != ''"
                color="primary"
                flat
                :href="$store.state.printhref"
                @click="closeDialog()"
            >
                Imprimir
            </v-btn>
            <v-btn
                v-if="$store.state.newCustNo != ''"
                color="primary"
                flat                
                @click="closeDialogNewCust()"
            >
                Pedido
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog> 
</template>
<script>
export default {
    name: 'globalDialog',
    data () {
      return {             
         
      }
    },
    methods:{                
        closeDialog(){
            if (this.$store.state.globalDialogData.returnMenu){
                this.navigate(1);
            }
            this.$store.state.printhref = '';
            this.globalDialog = false;
        },
        closeDialogNewCust(){
            if (this.$store.state.globalDialogData.returnMenu){
                this.navigate(1);
            }
            this.$store.state.newCust = false;
            this.$store.state.custFilter = this.$store.state.newCustNo;
            this.$store.state.newCustNo = '';
            this.globalDialog = false;
        }
    },
    computed: {     
        globalDialog:{
            get(){
                return this.$store.state.globalDialog;
            },
            set(value){
                this.$store.commit('setGlobalDialog', value)
            }
        }, 
        globalDialogData: {
            get(){
                return this.$store.state.globalDialogData;
            }
        }
    } 
}
</script>

